import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Menu, X } from 'lucide-react';
import { useState } from 'react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_74b64d1e-0f50-41cd-a085-d4779dba4423/artifacts/32j43v4s_Wild%20Thyme%20Logo.png";

export const Navigation = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const links = [
    { name: 'Home', path: '/' },
    { name: 'About', path: '/about' },
    { name: 'Experiences', path: '/experiences' },
    { name: 'Book Now', path: '/book' },
    { name: 'Contact', path: '/contact' },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <>
      {/* Desktop Navigation */}
      <motion.nav
        initial={{ y: -100, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
        className="hidden md:block fixed top-6 left-0 right-0 z-50 mx-auto max-w-5xl"
        data-testid="desktop-nav"
      >
        <div className="bg-white/80 backdrop-blur-xl border border-white/20 shadow-sm rounded-full px-8 py-4 flex items-center justify-between">
          <Link
            to="/"
            className="flex items-center gap-2 font-serif text-xl font-semibold text-[#3A4A3F] hover:text-[#D4A373] transition-colors"
            data-testid="nav-logo"
          >
            <img src={LOGO_URL} alt="Wild Thyme" className="w-8 h-8 object-contain" />
            Wild Thyme
          </Link>
          <div className="flex items-center gap-8">
            {links.map((link) => (
              <Link
                key={link.name}
                to={link.path}
                className={`text-sm font-medium transition-colors ${
                  isActive(link.path)
                    ? 'text-[#D4A373]'
                    : 'text-[#2C332B] hover:text-[#D4A373]'
                }`}
                data-testid={`nav-link-${link.name.toLowerCase().replace(' ', '-')}`}
              >
                {link.name}
              </Link>
            ))}
          </div>
        </div>
      </motion.nav>

      {/* Mobile Navigation */}
      <motion.nav
        initial={{ y: -100, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.6 }}
        className="md:hidden fixed top-4 left-4 right-4 z-50"
        data-testid="mobile-nav"
      >
        <div className="bg-white/80 backdrop-blur-xl border border-white/20 shadow-sm rounded-full px-6 py-4 flex items-center justify-between">
          <Link
            to="/"
            className="flex items-center gap-2 font-serif text-lg font-semibold text-[#3A4A3F]"
            data-testid="mobile-nav-logo"
          >
            <img src={LOGO_URL} alt="Wild Thyme" className="w-7 h-7 object-contain" />
            Wild Thyme
          </Link>
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="text-[#3A4A3F] p-2"
            data-testid="mobile-menu-toggle"
          >
            {isOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            className="mt-4 bg-white/95 backdrop-blur-xl border border-white/20 shadow-lg rounded-3xl p-6"
            data-testid="mobile-menu"
          >
            <div className="flex flex-col gap-4">
              {links.map((link) => (
                <Link
                  key={link.name}
                  to={link.path}
                  onClick={() => setIsOpen(false)}
                  className={`text-base font-medium transition-colors py-2 ${
                    isActive(link.path)
                      ? 'text-[#D4A373]'
                      : 'text-[#2C332B] hover:text-[#D4A373]'
                  }`}
                  data-testid={`mobile-nav-link-${link.name.toLowerCase().replace(' ', '-')}`}
                >
                  {link.name}
                </Link>
              ))}
            </div>
          </motion.div>
        )}
      </motion.nav>
    </>
  );
};
